import React, { useState } from "react";
import "./DocumentSelection.css";

function DocumentSelection({ onBack, onContinue }) {
  const [selectedDoc, setSelectedDoc] = useState("national-id");
  const [selectedCountry, setSelectedCountry] = useState("Spain");

  const handleContinue = () => {
    onContinue(selectedDoc, selectedCountry);
  };

  return (
    <div className="document-container">
      <div className="document-card">
        <div className="document-header">
          <button className="back-button" onClick={onBack}>
            ←
          </button>
          <div className="header-progress">
            <div
              className="header-progress-fill"
              style={{ width: "66%" }}
            ></div>
          </div>
        </div>

        <div>
          <h2 className="document-title">Which document will you use?</h2>
          <p className="document-subtitle">
            You must carry an official government ID
          </p>

          <div className="document-options">
            <label
              className={`document-option ${selectedDoc === "national-id" ? "selected" : ""}`}
            >
              <div className="option-content">
                <svg
                  className="option-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <rect
                    x="2"
                    y="4"
                    width="20"
                    height="16"
                    rx="2"
                    strokeWidth="2"
                  />
                  <path
                    d="M8 10h8M8 14h5"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <span className="option-label">National ID</span>
              </div>
              <input
                type="radio"
                name="document"
                value="national-id"
                checked={selectedDoc === "national-id"}
                onChange={(e) => setSelectedDoc(e.target.value)}
              />
            </label>

            <label
              className={`document-option ${selectedDoc === "passport" ? "selected" : ""}`}
            >
              <div className="option-content">
                <svg
                  className="option-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <rect
                    x="4"
                    y="2"
                    width="16"
                    height="20"
                    rx="2"
                    strokeWidth="2"
                  />
                  <circle cx="12" cy="10" r="3" strokeWidth="2" />
                  <path d="M9 16h6" strokeWidth="2" strokeLinecap="round" />
                </svg>
                <span className="option-label">Passport</span>
              </div>
              <input
                type="radio"
                name="document"
                value="passport"
                checked={selectedDoc === "passport"}
                onChange={(e) => setSelectedDoc(e.target.value)}
              />
            </label>

            <label
              className={`document-option ${selectedDoc === "drivers-license" ? "selected" : ""}`}
            >
              <div className="option-content">
                <svg
                  className="option-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <rect
                    x="1"
                    y="6"
                    width="22"
                    height="12"
                    rx="2"
                    strokeWidth="2"
                  />
                  <circle cx="7" cy="12" r="2" strokeWidth="2" />
                  <path
                    d="M12 10h6M12 14h4"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <span className="option-label">Driver's License</span>
              </div>
              <input
                type="radio"
                name="document"
                value="drivers-license"
                checked={selectedDoc === "drivers-license"}
                onChange={(e) => setSelectedDoc(e.target.value)}
              />
            </label>
          </div>

          {/* <div className="country-selection">
                    <label className="country-label-text">COUNTRY OF DOCUMENT</label>
                    <div className="country-dropdown">
                        <span className="country-flag">🇪🇸</span>
                        <select
                            className="country-select-input"
                            value={selectedCountry}
                            onChange={(e) => setSelectedCountry(e.target.value)}
                        >
                            <option value="Spain">Spain</option>
                            <option value="United States">United States</option>
                            <option value="United Kingdom">United Kingdom</option>
                            <option value="France">France</option>
                            <option value="Germany">Germany</option>
                            <option value="Pakistan">Pakistan</option>
                        </select>
                        <svg className="dropdown-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <polyline points="6 9 12 15 18 9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div> */}

          <div className="privacy-notice">
            <svg
              className="lock-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <rect
                x="5"
                y="11"
                width="14"
                height="10"
                rx="2"
                strokeWidth="2"
              />
              <path
                d="M8 11V7a4 4 0 018 0v4"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
            <span>
              Your information is only used for identity verification.
            </span>
          </div>
        </div>

        <div>
          <button className="continue-button" onClick={handleContinue}>
            Next
          </button>

          <div className="document-footer">Secured by VerifiLite</div>
        </div>
      </div>
    </div>
  );
}

export default DocumentSelection;
